/*
  cart-pin.js

  Keeps the cart icon visible at the top-right of the viewport when the
  user scrolls past the main header row. The site's main header row
  (containing the cart) scrolls off naturally, leaving only the sticky
  announcement bar + category nav visible. This script clones the cart
  icon into `<body>` and pins it position:fixed at the same right-edge
  offset the original cart occupies, so users can always access the cart
  from anywhere on the page.

  Purely additive — does not modify the original header markup, CSS, or
  scroll behavior. The clone mirrors the original's href, badge count,
  and any class changes (via a MutationObserver).
*/
(function () {
  if (typeof MutationObserver === 'undefined') return;

  function init() {
    var orig = document.querySelector('main-header a.area--cart');
    if (!orig) {
      /* Header not in DOM yet — retry briefly. */
      setTimeout(init, 300);
      return;
    }

    /* Build the clone. Reuse the inner HTML so the count badge + icon
       come along for the ride. */
    var clone = document.createElement('a');
    clone.className = 'area--cart nt-cart-pin';
    clone.setAttribute('href', orig.getAttribute('href') || '/cart');
    clone.setAttribute('aria-label', orig.getAttribute('aria-label') || 'Cart');
    clone.innerHTML = orig.innerHTML;
    /* Mirror any click behavior — clicking the pinned clone triggers a
       click on the original so existing handlers (e.g., cart drawer open)
       still run. */
    clone.addEventListener('click', function (e) {
      e.preventDefault();
      orig.click();
    });
    document.body.appendChild(clone);

    /* Keep clone in sync with the original's innerHTML (badge count
       updates after add-to-cart, etc.). Targeted MutationObserver, not
       on document.body. */
    new MutationObserver(function () {
      /* Avoid clobbering the clone's own injected scripts by re-copying
         only when content actually changes. */
      if (clone.innerHTML !== orig.innerHTML) {
        clone.innerHTML = orig.innerHTML;
      }
    }).observe(orig, { childList: true, subtree: true, characterData: true });

    /* Toggle visibility based on scroll position. Show only after the
       user has scrolled past the natural top of the cart, so it doesn't
       double-render at the top of the page. */
    var threshold = 60;
    function updatePos() {
      var natural = orig.getBoundingClientRect();
      var shouldShow = window.scrollY > threshold && natural.bottom < 30;
      document.body.classList.toggle('nt-show-pinned-cart', shouldShow);
      /* Position (top/right) is fully controlled by CSS now — no inline
         style overrides here. */
    }
    updatePos();
    window.addEventListener('scroll', updatePos, { passive: true });
    window.addEventListener('resize', updatePos, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
